import React from 'react';
import { NavLink } from 'react-router-dom';

const PageNavSavedLocation = ({id = null}) => {

    if(!id){
        return <></>
    }
    
    return (
        <nav>
            <ul className='flex justify-center gap-4 sm:gap-6 md:gap-8 sm:justify-start items-center text-xs sm:text-sm mt-8 border-b border-custom-charcoal'>

                <li className=''>
                    <NavLink 
                        to={`/location/${id}/forecast`}
                        className={({isActive}) => `font-semibold py-4 border-b-2 block ${isActive ? 'border-custom-light-blue text-custom-light-blue' : 'border-transparent'}`}
                    >
                        Forecast
                    </NavLink>
                </li>
                <li className=''>
                    <NavLink 
                        to={`/location/${id}/view`}
                        className={({isActive}) => `font-semibold py-4 border-b-2 block ${isActive ? 'border-custom-light-blue text-custom-light-blue' : 'border-transparent'}`}
                    >
                        Overview
                    </NavLink>
                </li>
                <li className=''>
                    <NavLink 
                        to={`/location/${id}/preferences`}
                        className={({isActive}) => `font-semibold py-4 border-b-2 block ${isActive ? 'border-custom-light-blue text-custom-light-blue' : 'border-transparent'}`}
                    >
                        Ideal&nbsp;Conditions
                    </NavLink>
                </li>
                <li className=''>
                    <NavLink 
                        to={`/location/${id}/edit`}
                        className={({isActive}) => `font-semibold py-4 border-b-2 block ${isActive ? 'border-custom-light-blue text-custom-light-blue' : 'border-transparent'}`}
                    >
                        Manage
                    </NavLink>
                </li>   
                {/* <li className=''>
                    <NavLink 
                        to={`/location/${id}/alerts`}
                        className={({isActive}) => `font-semibold py-4 border-b-2 block ${isActive ? 'border-custom-light-blue text-custom-light-blue' : 'border-transparent'}`}
                    >
                        Alerts
                    </NavLink>
                </li>              */}
            </ul>
        </nav>
    )
}

export default PageNavSavedLocation;